import type { InjectionKey } from 'vue';
import type { DivisibleRemote } from './types';

export const loading = Symbol('LoadingPlaceholder');

/**
 * The default key used to inject dynamic remotes.
 */
export const defaultDivisibleRemote = Symbol() as InjectionKey<
    Readonly<DivisibleRemote>
>;
